<template lang="">
    <div class="modal fade" :id="modalId" ref="modalEl" tabindex="-1"  :aria-labelledby="`${modalId}-label`" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" :id="`${modalId}-label`">{{ title }}</div>
        <button class="btn btn-default btn-sm close-btn" @click="handleClose">
            <CloseIcon/>
        </button>
      </div>
      <div class="modal-body">
        <div ref="croppieContainer" class="croppie-box"></div>
            <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
          
      </div>
      <div class="modal-footer">

        <button type="button"
        class="btn btn-secondary save-btn"
        style="color:var(--enterprise-button);background:var(--page-header)"
        @click="getResult" v-if="loading" disabled>Saving...</button>
        <button type="button"
        class="btn btn-secondary save-btn"
        style="color:var(--enterprise-button);background:var(--page-header)"
        @click="getResult" v-else>{{ buttonLabel || "Save" }}</button>

      </div>
    </div>
  </div>
</div>
</template>
<script>
import { Modal } from 'bootstrap';
import Croppie from 'croppie';
import {changeProfilePictureAsync} from '@/services/userProfileService';
import LoadingIndicator from '../Utility/LoadingIndicator.vue';
import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
  components:{
    LoadingIndicator, CloseIcon
  },
   data() {
    return {
      croppie: null,
      imageLoaded: false,
      result: null,
      errors:[],
      loading:false,
      hasErrors:false,
    }
  },
  computed:{
    selectedImage(){
      return this.$store.getters["profile/getSelectedImage"];
    }
  },
    props:{
        // closeModal:{
        //     type: Function,
        //     required: true            
        // },
        title:{
            type: String,
            required: true
        },
        buttonLabel:{
          type:String
        },
        modalId:{
            type: String,
            required: true
        },
        file:{
          type: File
        },
        updateDisplayPicture: Function
    },
     mounted() {
    this.modalInstance = new Modal(this.$refs.modalEl);
   
   },
   watch: {
    file: {
      immediate: false,
      handler(newFile) {
        if (!newFile) return

        // open modal automatically
        this.show()

        // croppie must wait for modal animation to finish
        // so DO NOT init here
      }
    }
  },
  watch:{
    file:{
      handler(newValue){
       this.initializeCropper()
      },
      immediate: false
    }
  },
    methods: {
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      },
      initializeCropper(){
          // destroy old instance (VERY IMPORTANT)
      if (this.croppie) {
        this.croppie.destroy();
        this.croppie = null;
      }
        this.$nextTick(() => {
        this.croppie = new Croppie(this.$refs.croppieContainer, {
          viewport: { width: this.remToPixels(15.5),
                      height: this.remToPixels(15.5),
                      type: "square"
                    },
          boundary: { width: this.remToPixels(23.2),
                      height: this.remToPixels(18.75)
                    },
          enableExif: true,
          showZoomer: true,
          enforceBoundary: true
            
        })

        const reader = new FileReader();


        reader.onload = (event) => {
      // Bind the image data
      this.croppie.bind({
        url: event.target.result
      }).then(() => {
        const slider = this.$refs.croppieContainer.querySelector('.cr-slider');
        if (slider) {

          // 1. Get Croppie's relative calculated minimum attribute
          const calculatedMin = parseFloat(slider.getAttribute('min') || "0");
          
          // 2. Clamp it: Use Croppie's math, but NEVER let it go below 0.2
          const strictMin = Math.max(calculatedMin, 0.2);
          
          // 3. Set the forced attributes on the input element
          slider.setAttribute('min', strictMin.toString());
          slider.setAttribute('step', '0.0001'); 
          
          // 4. Safety check: If the slider's current value is now below your new 0.2 limit, push it up
          if (parseFloat(slider.value) < strictMin) {
            slider.value = strictMin.toString();
            // Tell Croppie to update the image preview position to reflect the new zoom value
            this.croppie.setZoom(strictMin); 
          }
          
          slider.dispatchEvent(new Event('input'));

        }
      });
      
      this.imageLoaded = true;
    };

    reader.readAsDataURL(this.file);
    
      });
      },
      handleClose(){
       
        if (this.croppie) {
        this.croppie.destroy()
        this.croppie = null
      }
      this.hide();
       
      },
       async getResult(){
        try{
        this.resetOnNewSubmit()
        this.result = await this.croppie.result({
          type: "base64",
          size: "viewport",
          format: "png",
          quality: 1
        })
        var data = await changeProfilePictureAsync(this.result,this.handleClose);
            this.loading = false;
            if(data.success){
                this.updateDisplayPicture(this.result);
                this.handleClose();
        }else{
          console.log(data);
            if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                });
                this.hasErrors = true;
                return;
            }
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            this.errors.push(e.message);
            this.hasErrors = true;
            setTimeout(() => this.removeErrors(), 2000);
        }
      },
       resetOnNewSubmit(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
     remToPixels(rem) {
      return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      },
      removeErrors(){
        this.hasErrors = false;
        this.errors = [];
      }
    }


}
</script>
<style scoped>

.errors{
  margin:0rem 0.6rem;
}

/* 1. Use :deep() to force Vue to style elements dynamically injected by Croppie */
.croppie-box :deep(.cr-slider) {
    background: transparent !important;
    border: 0px !important;
    width:100%;

    /* Standard property first or last depending on your autoprefixer setup */
    appearance: none; 
    -webkit-appearance: none; /* Safely included as a prefix fallback for WebKit engines */
    -moz-appearance: none;    /* Safely included as a prefix fallback for older Gecko engines */
    height: 16px!important;
    border-radius: 3px;
}

.croppie-box :deep(.cr-slider-wrap){
  margin-left:62.3px;
  margin-right:62.3px;
  margin-top:14px;
  margin-bottom:0.3rem;
}

.croppie-box :deep(.cr-boundary){
  border-radius: 8px;
}

.save-btn{
  width:100%;
  margin:0.6rem;
}

/* 2. Style the Thumb for Chrome, Safari, Edge, and Opera (WebKit) */
.croppie-box :deep(.cr-slider::-webkit-slider-thumb) {
    appearance: none;
    -webkit-appearance: none;
  
    background: var(--page-header, #007bff); /* Uses your custom tertiary color */
    cursor: pointer;
    border: none;
    transition: transform 0.1s ease;
}

.croppie-box :deep(.cr-slider::-webkit-slider-thumb:hover) {
    transform: scale(1.15); /* Slightly enlarge on hover */
}

/* 3. Style the Thumb for Firefox */
.croppie-box :deep(.cr-slider::-moz-range-thumb) {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--page-header, #007bff);
    cursor: pointer;
    border: none;
    transition: transform 0.1s ease;
}

.croppie-box :deep(.cr-slider::-moz-range-thumb:hover) {
    transform: scale(1.15);
}

#cropImage.modal.fade.show{
  background-color: rgba(165, 96, 255, 0.082)!important;
  backdrop-filter: blur(6px);
}

  /* MODAL */
    .modal-body{
        color:var(--foreground);
        padding:0px;
        padding-top:0.5rem;
    }

    .modal-footer{
      padding:0px;
    }


  
    .modal-header{
      border-bottom:0px;
    }

    .modal-content{
      border-radius: 16px;
    }

    


   
</style>